import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19835180"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "qrcode-box",
  "element-loading-text": "加载中..."
}
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.source,
          class: "qrcode-image-box"
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true)
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}